'use client';
import { useEffect, useRef, useState } from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';
import styles from './styles.module.css';

export interface ResponsiveVideoPlayerProps extends ReactPlayerProps {
  url: string;
  seekTo?: number | null;
}

export default function ResponsiveVideoPlayer({
  url,
  seekTo,
  onStart,
  ...props
}: ResponsiveVideoPlayerProps) {
  const playerRef = useRef<ReactPlayer>(null);
  const [hasWindow, setHasWindow] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHasWindow(true);
    }
  }, []);

  if (!hasWindow) {
    return null;
  }

  const onPlayerStart = () => {
    if (onStart) {
      onStart();
    }
    if (seekTo && playerRef.current) {
      playerRef.current.seekTo(seekTo as number, 'seconds');
    }
  };

  return (
    <div className={styles.videoContainer}>
      <ReactPlayer
        ref={playerRef}
        fallback={
          <div className="flex h-[25vh] w-full items-center justify-center">
            <p>laster...</p>{' '}
          </div>
        }
        controls={true}
        className={styles.react_player}
        url={url}
        width="100%"
        height="100%"
        onStart={onPlayerStart}
        {...props}
      />
    </div>
  );
}
